import { render } from "./GaleryBlock.vue?vue&type=template&id=2262cddd"
import script from "./GaleryBlock.vue?vue&type=script&lang=js"
export * from "./GaleryBlock.vue?vue&type=script&lang=js"

import "./GaleryBlock.vue?vue&type=style&index=0&id=2262cddd&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__